export default function CollectionPageJsonLd() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Guia de Compras — HoobuySpreadsheet 2026',
    description: 'Conteúdo original e otimizado sobre o HoobuySpreadsheet. Guias, tutoriais, dicas e comparações para você comprar melhor e com segurança em 2026.',
    url: 'https://hoobuy.website/guia-de-compras',
    inLanguage: 'pt',
    isAccessibleForFree: true,
    publisher: {
      '@type': 'Organization',
      name: 'hoobuy.website',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg',
      },
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          url: 'https://hoobuy.website/artigo/guia-completo-hoobuyspreadsheet',
        },
        {
          '@type': 'ListItem',
          position: 2,
          url: 'https://hoobuy.website/artigo/como-economizar-compras-online',
        },
        {
          '@type': 'ListItem',
          position: 3,
          url: 'https://hoobuy.website/artigo/hoobuyspreadsheet-vs-concorrentes',
        },
        {
          '@type': 'ListItem',
          position: 4,
          url: 'https://hoobuy.website/artigo/seguranca-em-compras-internacionais',
        },
        {
          '@type': 'ListItem',
          position: 5,
          url: 'https://hoobuy.website/artigo/categorias-mais-populares-hoobuy',
        },
        {
          '@type': 'ListItem',
          position: 6,
          url: 'https://hoobuy.website/artigo/dicas-para-compras-online-2026',
        },
        {
          '@type': 'ListItem',
          position: 7,
          url: 'https://hoobuy.website/artigo/atualizacoes-hoobuyspreadsheet',
        },
        {
          '@type': 'ListItem',
          position: 8,
          url: 'https://hoobuy.website/artigo/como-encontrar-melhores-ofertas',
        },
        {
          '@type': 'ListItem',
          position: 9,
          url: 'https://hoobuy.website/artigo/tutorial-hoobuyspreadsheet-iniciantes',
        },
        {
          '@type': 'ListItem',
          position: 10,
          url: 'https://hoobuy.website/artigo/beneficios-planilha-inteligente',
        },
      ],
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}